
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { StewieShield } from '../StewieShield';
import { ComplianceQuickActions } from '../ComplianceQuickActions';
import { ComplianceHealthCard } from '../ComplianceHealthCard';
import CommunicationsMonitor from '../CommunicationsMonitor';
import { RecentDiscussionsWidget } from '../RecentDiscussionsWidget';

export const OverviewTab = () => {
  return (
    <>
      {/* StewieShield as the primary feature */}
      <StewieShield />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-8">
        {/* Recent Discussions Widget */}
        <RecentDiscussionsWidget />

        {/* Compliance Health Card with Heat Map */}
        <ComplianceHealthCard />
        
        {/* Quick Actions Card */}
        <ComplianceQuickActions />
      </div>
      
      <div className="mt-6">
        <CommunicationsMonitor />
      </div>
    </>
  );
};
